module.exports = __webpack_public_path__ + "img/AI-banner.96fb258f.png";